module.exports = __webpack_public_path__ + "img/ico_heart--white.00c9a447.svg";